// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3jpK6","top":"styles_top__3_Oq8"};